export { CreateCourseRequest } from './create-course.request';
export { UpdateCourseRequest } from './update-course.request';

export type { CreateCourseFormValues } from './create-course.request';
export type { UpdateCourseFormValues } from './update-course.request';
